define('plugin/news/model/NewsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * News data model
     *
     * @class NewsModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/news/by/id/',

        defaults: {
            id: '',
            date: '',
            name: '',
            short_content: '',
            content: ''
        }

    });

});
